import React from "react";

const Card = ({ zIndex = 1, backgroundImage, children }) => (
  <div className='affinite_card' style={{ zIndex, backgroundImage}}>{children}</div>
);

export default Card;
